import React from 'react';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { useLocation, useNavigate } from 'react-router-dom';
import RefundForm from '../components/RefundForm';
import { Stack } from '@mui/material';
import { generalPublicDetails } from '../../../utils/generalPublicDetails';
import { useCreateRefundHandler } from '../dataHandlers/createRefundHandler';

export default function CreateRefundPage() {
  useDocumentTitle('Refund Form');
  const navigate = useNavigate();
  const location = useLocation();
  const document = location.state?.document;

  const onRefundCreated = ({ payload }) => {
    if (payload.status === 'draft') {
      navigate('/drafts?tab=refunds');
    } else {
      navigate('/documents?tab=refunds');
    }
  };

  const { onSubmit, error } = useCreateRefundHandler({ onSuccess: onRefundCreated });

  const onSaveAsEInv = async (data) => {
    const payload = {
      ...data,
      status: 'active',
      billed_to: data?.billed_to || {},
    };

    await onSubmit(payload, data.status);
  };
  const onSaveAsDraft = async (data) => {
    const payload = {
      ...data,
      status: 'draft',
      billed_to: data.billed_to ? data.billed_to : generalPublicDetails,
    };
    await onSubmit(payload, data.status);
  };

  const onCancel = async () => {
    navigate(location.state?.from || '/documents?tab=refunds');
  };

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <RefundForm
        initialData={document || {}}
        onSubmit={onSaveAsEInv}
        onSaveDraft={onSaveAsDraft}
        onCancel={onCancel}
        apiErrors={error}
        isDraftButtonEnabled={location.state?.isDraftButtonEnabled}
      />
    </Stack>
  );
}
